import React from 'react';
import * as styles from './popout.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Popout = _ref => {
  var align = _ref.align,
    children = _ref.children,
    className = _ref.className;
  return ___EmotionJSX("div", {
    css: styles.popout({
      align
    }),
    className: className
  }, ___EmotionJSX("div", {
    css: styles.arrowOuter({
      align
    })
  }, ___EmotionJSX("div", {
    css: styles.arrowInner
  })), children);
};
export default Popout;